import { Button, Modal } from 'semantic-ui-react';
import EditComunidadEmpresa from 'src/containers/comunidad-network/edit/EditComunidadEmpresa';

const EditComunidadEmpresaModal = (props) => {
  const { inputs, set_showComunidadNetwork, onSaved } = props;
  const close = () => set_showComunidadNetwork(null);

  return (
    <Modal open={true} onClose={close}>
      <Modal.Content>
        <Modal.Description>
          <Button onClick={close} secondary>
            Cerrar
          </Button>
          <EditComunidadEmpresa record={inputs} onClose={close} onSaved={onSaved} />
        </Modal.Description>
      </Modal.Content>
    </Modal>
  );
};

export default EditComunidadEmpresaModal;
